import { http } from 'interfaces'
import { type State } from 'services'

export const searchStatesByCountry = async (countryId: number): Promise<State[]> => {
  const urlPath = `/api/v1/states/country/${countryId}/`
  return await http.get(urlPath)
    .then(value => value.data)
    .catch(() => { return [] })
}

export const addState = async (state: State): Promise<{ id: number }> => {
  return await http.post('/api/v1/states/', {
    state_desc: state.name,
    countryId: state.countryId
  }).then(response => response.data)
}
